import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {AxiosError} from 'axios'
import {FormErrorResponse} from '@/types'
import {httpCreateMedicalReport, HttpMedicalReportPayload} from '../http/medicalReports.http'

type CreateMedicalReportPayload<T> = T extends {status: 'draft'} ? Partial<T> : T

export const useCreateMedicalReport = <T extends HttpMedicalReportPayload>(
    options?: UseMutationOptions<unknown, AxiosError<{errors: FormErrorResponse[]}>, CreateMedicalReportPayload<T>>
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.CREATE_MEDICAL_REPORT],
        mutationFn: httpCreateMedicalReport
    })
}
